import cn from 'classnames';

import * as T from './LayoutConfines.types';

import css from './LayoutConfines.module.scss';

export default function LayoutConfines({
  children,
  extra = false,
  topOffset = false,
  className,
}: T.ILayoutConfinesProps) {
  return (
    <div
      className={cn(
        css.wrapper,
        extra && css.extra,
        topOffset && css.topOffset,
        className
      )}
    >
      {children}
    </div>
  );
}
